import React from 'react';

const LoadingMessage = () => { 
	return (
		<div>
			<br/>
			<br/>
			<br/>
			<br/>
			<br/>
			<br/>
			<h1 style={{textAlign: 'center'}}>
				<i className='fa fa-spinner fa-spin' />
				&nbsp;Loading User Data
			</h1>
		</div>
	)
}

export default LoadingMessage;